import { isEmpty, map } from 'lodash/fp';

import { CmsInsuranceTypeContent, Section } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import insertAwardTiles from '../../insert-award-tiles';

type MapAwardsContent = {
  awards?: CmsInsuranceTypeContent['award'] | null;
  sections: Section[];
};

const mapAwardsContent = ({ awards, sections }: MapAwardsContent) => {
  if (isEmpty(awards)) {
    return sections;
  }
  const mappedAwardTiles = map((award) => ({ ...award, type: CONTENT_SECTIONS.AWARD }), awards);
  return insertAwardTiles({ awardTiles: mappedAwardTiles, sections });
};

export default mapAwardsContent;
